import type { KeyboardEvent, ReactNode } from 'react';

import type { AssetLibraryViewMode } from '../assetLibraryGridLayout';

export function getAssetLibraryCardLayoutClasses(compact: boolean) {
  return {
    gapClass: compact ? 'gap-2' : 'gap-4',
    paddingClass: compact ? 'p-2 pb-2' : 'p-2 pb-4',
    titleToken: compact
      ? ({ base: '12/medium', sm: '14/medium' } as const)
      : ('16/medium' as const),
  };
}

export interface AssetLibraryCardShellProps {
  compact?: boolean;
  layout?: AssetLibraryViewMode;
  interactive?: boolean;
  selected?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: ReactNode;
}

export default function AssetLibraryCardShell({
  compact = false,
  layout = 'grid',
  interactive = false,
  selected = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
}: AssetLibraryCardShellProps) {
  const { gapClass, paddingClass } = getAssetLibraryCardLayoutClasses(compact);
  const isListLayout = layout === 'list';

  return (
    <article
      className={`flex min-w-0 ${isListLayout ? 'flex-row items-center gap-4' : `flex-col ${gapClass}`} ${paddingClass} rounded-2xl transition-colors ${
        selected ? 'bg-blue-15 dark:bg-blue-90' : 'hover:bg-secondary'
      } ${interactive ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={onClick}
      onKeyDown={
        interactive
          ? (event: KeyboardEvent<HTMLElement>) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </article>
  );
}
